var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup438(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(-143.226 -95.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 20,
    height: 20,
    transform: "translate(143.226 95.005)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M150.794,111.522h-4.968a.535.535,0,0,1-.6-.607,5.562,5.562,0,0,1,10.978-1.191,7.162,7.162,0,0,1,.15,1.235.518.518,0,0,1-.56.562Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M153.838,101.541a3.051,3.051,0,1,1-3.111-3.052A3.068,3.068,0,0,1,153.838,101.541Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M157.356,110.018a6.746,6.746,0,0,0-2.149-3.979,3.613,3.613,0,0,1,1.078-.446,3.993,3.993,0,0,1,4.862,3.072,4.738,4.738,0,0,1,.079.809.508.508,0,0,1-.5.54C159.607,110.023,158.485,110.018,157.356,110.018Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M154.962,102.582a2.267,2.267,0,1,1,2.252,2.273A2.254,2.254,0,0,1,154.962,102.582Z",
    fill: "#586973"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup438);
export default __webpack_public_path__ + "static/media/Group 438.2043e60b.svg";
export { ForwardRef as ReactComponent };